import {Pipe,PipeTransform} from '@angular/core'

@Pipe({
  'name':"GoalTime"
})

export class GoalTime implements PipeTransform{
  public transform(val):string{
    if(val!=null){
      if(val==1){
        return "Now"
      }
      else if(val==2){
        return "Next Week"
      }
      else if(val==3){
        return "In 2 Week"
      }
      else if(val==4){
        return "Next Month"
      }
      else
      return "Can't Plan Now"
    }
  }
}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/module-page/goal-time.ts